import api from '../../../api';
import type { PayslipDetail } from '../../../../types/Payroll';
import type { PayslipHistoryItem } from '../../../../types/History';

const TEMP_HOURS_KEY = 'payrollTempHours';

type TempHoursEntry = { employeeId: number; date: string; hours: number };

export function setTempHours(entry: TempHoursEntry) {
  sessionStorage.setItem(TEMP_HOURS_KEY, JSON.stringify(entry));
}

export function clearTempHours() {
  sessionStorage.removeItem(TEMP_HOURS_KEY);
}

// Temp hours only count for the employee they were entered for, and only on the day they were entered.
export function getTempHours(employeeId: number, today: string): number | null {
  try {
    const entry = JSON.parse(sessionStorage.getItem(TEMP_HOURS_KEY) ?? 'null') as TempHoursEntry | null;
    if (!entry || entry.employeeId !== employeeId || entry.date !== today) return null;
    return entry.hours;
  } catch {
    return null;
  }
}

export async function fetchTempHoursEligibility(employeeId: number): Promise<{ eligible: boolean; date: string }> {
  const response = await api.get<{ eligible: boolean; date: string }>(
    `/payroll/payslips/temp-hours-eligibility?employeeId=${employeeId}`
  );
  return response.data;
}

function todayLocal(): string {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

export async function fetchPayslipByEmployeeId(employeeId: number, payDate?: string): Promise<PayslipDetail> {
  const payDateQuery = payDate ? `&payDate=${encodeURIComponent(payDate)}` : '';
  const tempHours = getTempHours(employeeId, todayLocal());
  const tempQuery = tempHours ? `&tempHours=${tempHours}` : '';
  const response = await api.get<{ payslip: PayslipDetail }>(`/payroll/payslips?employeeId=${employeeId}${payDateQuery}${tempQuery}`);
  return response.data.payslip;
}

export async function fetchPayslipHistory(employeeId: number): Promise<PayslipHistoryItem[]> {
  const response = await api.get<{ history?: PayslipHistoryItem[] }>(`/payroll/payslips/history?employeeId=${employeeId}`);
  return Array.isArray(response.data.history) ? response.data.history : [];
}

export async function downloadPayslip(payslipId: number): Promise<any> {
  const response = await api.get<{ payslip: any }>(`/payroll/payslips/download/${payslipId}`);
  return response.data.payslip;
}
